export default class AuditFilter {
    public page = 0;
    public size = 20;
    public events: string[] = [];
    public producerId: number | null = null;
    public consumerId: number | null = null;
    public dateTimeFrom: string | null = null;
    public dateTimeTo: string | null = null;
}